/** Shared shell dimensions - fixed app header + bottom navigation. */
export const APP_HEADER_HEIGHT_PX = 56;
/** @deprecated Use APP_HEADER_HEIGHT_PX - kept for imports */
export const APP_HEADER_TOTAL_PX = APP_HEADER_HEIGHT_PX;

/** Base nav bar height. */
export const APP_NAV_BASE_HEIGHT_PX = 64;
/** Extra clearance below nav (legacy FAB overhang - now 0 with uniform tab layout). */
export const APP_NAV_FAB_CLEARANCE_PX = 0;
/** Total bottom nav footprint used for fixed overlays (nav + FAB clearance + safe area). */
export const APP_NAV_TOTAL_HEIGHT_PX = APP_NAV_BASE_HEIGHT_PX + APP_NAV_FAB_CLEARANCE_PX;
/** Approximate height of the ride sticky action bar (distance + buttons row). */
export const APP_STICKY_ACTION_BAR_HEIGHT_PX = 72;

export const shellStyles = {
  header: {
    height: APP_HEADER_HEIGHT_PX,
    paddingTop: 'env(safe-area-inset-top)',
  } as const,
  main: {
    paddingTop: `calc(${APP_HEADER_HEIGHT_PX}px + env(safe-area-inset-top))`,
    paddingBottom: `calc(${APP_NAV_BASE_HEIGHT_PX + APP_NAV_FAB_CLEARANCE_PX}px + env(safe-area-inset-bottom))`,
  } as const,
  bannerTop: `calc(${APP_HEADER_HEIGHT_PX}px + env(safe-area-inset-top))`,
} as const;

/** Position fixed ride action bars just above the bottom tab bar. */
export const stickyActionBarBottom = `calc(${APP_NAV_TOTAL_HEIGHT_PX}px + env(safe-area-inset-bottom))`;

/** Main scroll padding when the ride sticky action bar is visible. */
export const stickyActionBarScrollPadding = `calc(${APP_NAV_TOTAL_HEIGHT_PX + APP_STICKY_ACTION_BAR_HEIGHT_PX}px + env(safe-area-inset-bottom))`;
